import { redirect } from "react-router-dom"

import { getSubscriptionApi, isHeldSubscription } from "@/entities/subscription"

import { store } from "../../store"

/**
 * Sends non-holders to Finance before the page renders; rendering first flashed an empty page on the way there.
 * A failed read renders the page, whose own query shows the error and retries.
 */
export const personalSubscriptionLoader = async () => {
  const request = store.dispatch(getSubscriptionApi.endpoints.getPersonalSubscription.initiate(undefined))

  try {
    const subscription = await request.unwrap()
    return isHeldSubscription(subscription) ? null : redirect("/user-profile/finance")
  } catch {
    return null
  } finally {
    request.unsubscribe()
  }
}
